var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { createContext, useMemo, useReducer, useContext } from "react";
var initalState = {
    progress: 0,
    timeLeftSide: "--:--",
    timeRightSide: "--:--",
};
var StateContext = createContext(initalState);
var ActionsContext = createContext(undefined);
var PlayerStateReducer = function (state, action) {
    switch (action.type) {
        case "UPDATE_PROGRESS":
            return __assign(__assign({}, state), { progress: action.progress, timeLeftSide: action.timeLeftSide, timeRightSide: action.timeRightSide });
        default:
            return state;
    }
};
export var PlayerStateProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(PlayerStateReducer, initalState), state = _b[0], dispatch = _b[1];
    var actions = useMemo(function () { return ({
        updateStateProgress: function (progress, timeLeftSide, timeRightSide) {
            return dispatch({
                type: "UPDATE_PROGRESS",
                progress: progress,
                timeLeftSide: timeLeftSide,
                timeRightSide: timeRightSide,
            });
        },
    }); }, [dispatch]);
    return (React.createElement(ActionsContext.Provider, { value: actions },
        React.createElement(StateContext.Provider, { value: state }, children)));
};
export var usePlayerStateActions = function () {
    var context = useContext(ActionsContext);
    if (!context)
        throw new Error("usePlayerStateActions must be used within Provider");
    return context;
};
export var usePlayerStateData = function () {
    var context = useContext(StateContext);
    if (!context)
        throw new Error("usePlayerStateData must be used within Provider");
    return context;
};



//////////////////
// WEBPACK FOOTER
// ./src/context/PlayerStateContext.tsx
// module id = 43
// module chunks = 1